import { Collectible } from '../collectible';
import { Project } from '../project';
import { User } from '../user';

export type Mute = {
	id?: number;
	user?: User;
	project?: Project;
};
